module.exports = __webpack_public_path__ + "static/media/img-msg-hurry-up@3x.0b9db980.png";